import { ICenter, IProductCenter, IProduct } from ".";

export interface ICrmAccountPlan {
    center: ICenter,
    targetedProducts: IProductCenter[],
    closedProducts: IProductCenter[],
    availableProducts: IProduct[],
    notes: string
}
